import React, { useState } from 'react';
import ImageUpload, { SelectedImage } from '../../components/ImageUpload/ImageUpload';
import ImageEditor from '../../components/ImageEditor/ImageEditor';
import './Editor.css';

const STEPS = [
  {
    number: '01',
    title: 'Choose an image',
    body: 'PNG, JPG or WEBP, up to 15 MB. It is read straight off your disk.',
  },
  {
    number: '02',
    title: 'Make your edits',
    body: 'Crop and rotate, tune exposure and colour, add text, shapes and a watermark.',
  },
  {
    number: '03',
    title: 'Download it',
    body: 'Pick the format, quality and size on the way out.',
  },
];

const Editor = () => {
  const [image, setImage] = useState<SelectedImage | null>(null);

  return (
    <div className="editor-page">
      <section className="editor-lede">
        <div className="editor-lede-copy">
          <p className="eyebrow editor-eyebrow">Free &middot; In your browser &middot; No account required</p>
          <h1 className="editor-title">
            An image editor that <em>never sees</em> your images.
          </h1>
          <p className="editor-subtitle">
            Crop, straighten, adjust and annotate &mdash; all on your device. Nothing is uploaded
            and nothing is stored.
          </p>
        </div>
        <ImageUpload onImageSelected={setImage} />
      </section>

      <ol className="editor-steps">
        {STEPS.map((step) => (
          <li className="editor-step" key={step.number}>
            <span className="editor-step-number">{step.number}</span>
            <h2 className="editor-step-title">{step.title}</h2>
            <p className="editor-step-body">{step.body}</p>
          </li>
        ))}
      </ol>

      {image && (
        <ImageEditor source={image.dataUrl} fileName={image.fileName} onClose={() => setImage(null)} />
      )}
    </div>
  );
};

export default Editor;
